/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import TemplateModel from 'cio/models/template';

interface SlackActionArgs {
  action: ActionModel;
  disableOverlay: boolean;
  hasContent: boolean;
  disabled: boolean;
  template: TemplateModel | null;
  sanitizedBody: string;
  hasReadOnlyPermission: boolean;
}

export default class SlackAction extends Component<SlackActionArgs> {
  avatarOutlineImage = new URL('cio/assets/images/avatar-outline.png', import.meta.url).toString();
}
